import React, { useContext, useEffect, useState } from 'react';
import ButtonCancelForm from '../../../../components/buttons/ButtonCancelForm';
import { ServiceResponse } from '../../../../app/services/shared/interfaces';
import { AppContext } from '../../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../../hooks/useReactConfirmAlert';
import LazyLoading from '../../../../components/LazyLoading';
import { Worker } from '../../../../app/models/Workers';
import CalendarDeteleEventsByDatesForm from '../forms/CalendarDeteleEventsByDatesForm';
import useEventService from '../../../../app/services/hooks/useEventService';
import { CalendarEvent, defaultCalendarEventDataForm } from '../../../../app/models/Event';
import ButtonDeleteForm from '../../../../components/buttons/ButtonDeleteForm';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
    workerId?: number;
    showWorkerField?: boolean;
}

const CalendarDeleteEventsByDates = ({
    onSaved,
    onCancel,
    onError,
    workerId,
    showWorkerField
}: Props) => {
    const [calendarEvent, setCalendarEvent] = useState<CalendarEvent>({
        ...defaultCalendarEventDataForm
    });
    const [workers, setWorkers] = useState<Worker[]>([]);
    const [errorFields, setErrorFields] = useState<any>();

    const { deleteEventsByDates, fetchingDeleteEventsByDates } = useEventService();

    const { showLoading, hideLoading } = useContext(AppContext);



    useEffect(() => {
        if (workerId) {
            setCalendarEvent({ ...calendarEvent, worker_id: workerId });
        }
    }, [workerId]);

    const deleteByDates = () => {

        if(!calendarEvent.worker_id || !calendarEvent.start_date || !calendarEvent.end_date){

            useReactConfirmAlert().warningAlert({
                title: 'Campos incompletos',
                message: 'Ambas fechas son obligatorias.'
            });
        } else{
            if (showLoading) showLoading('loading', 'Cargando solicitud...');

            deleteEventsByDates(
                calendarEvent.worker_id, 
                calendarEvent.start_date.toString(), 
                calendarEvent.end_date.toString(),
                {
                    onSuccess: (response: ServiceResponse) => {
                        if (hideLoading) hideLoading();
                        useReactConfirmAlert().successAlert({
                            title: 'Éxito',
                            message: response.message
                        });
                        toast.success(response.message, {
                            autoClose: 2500
                        });
                        if (onSaved) onSaved();
                    },
                    onError: (response: ServiceResponse) => {
                        if (hideLoading) hideLoading();
                        useReactConfirmAlert().errorAlert({
                            title: 'Error',
                            message: response.message
                        });
                    },
                }
            )
        }   
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return (
        <>
            <CalendarDeteleEventsByDatesForm
                calendarEvent={calendarEvent}
                setCalendarEvent={setCalendarEvent}
                workers={workers}
                errorFields={errorFields}
                showWorkerField={showWorkerField}
            />
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} />
                </div>
                <div className="col-auto">
                    <ButtonDeleteForm callbackDelete={deleteByDates} />
                </div>
            </div>
        </>
    );
};

export default CalendarDeleteEventsByDates;
